<template>
  <div>
    <CRow>
      <CCol sm="12">
        <MyAccountFiscalForm
          :items="customers"
          hover
          striped
          border
          small
          fixed
          caption="Información Fiscal"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import MyAccountFiscalForm from '../../components/configuration/MyAccountFiscalForm.vue'
import customers from '../../services/customers';
import store from '../../store'

export default {
  name: 'Fiscal',
  components: { MyAccountFiscalForm },
  data: function () {
		return {
            customers: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await customers.get(); 

    if(response.type == "success"){
      this.customers = response.data;
    }
    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.customers = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
